export enum GoogleAuthDownloadLink {
  AppStore = 'https://apps.apple.com/us/app/google-authenticator/id388497605',
  GooglePlay = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en',
}
